module.exports = __webpack_public_path__ + "static/media/Ecrans bornes CUISINE V3-page-003.1329b17f.jpg";